import type { SelectOption } from '@/components/ui/SelectOptions/types';
import type { GetWorkstationsResponseDTO } from '@/core/dto/workstation/get-workstations';

export class GetWorkstationsMapper {
	constructor(private readonly data: GetWorkstationsResponseDTO) {}

	toDomain(): SelectOption[] {
		return this.data.map((value) => ({
			value: value.id,
			label: value.name
		}));
	}
}
